import { render } from "./radio-input.vue?vue&type=template&id=3f8037be&scoped=true"
import script from "./radio-input.vue?vue&type=script&lang=js"
export * from "./radio-input.vue?vue&type=script&lang=js"

import "./radio-input.vue?vue&type=style&index=0&id=3f8037be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8037be"]])

export default __exports__